import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { EmailIcon, TelegramIcon, ViberIcon, WhatsappIcon } from "react-share";

const ICON_SIZE = 24;
const COPIED_MS = 1800;
// matches the width of .hs-share-menu
const MENU_WIDTH = 210;
const SCREEN_MARGIN = 12;

// Viber and email hand over to an app, so they do not need a tab of their own
const NETWORKS = [
    { name: 'Viber', Icon: ViberIcon, link: (url, text) => `viber://forward?text=${text}%20${url}` },
    { name: 'WhatsApp', Icon: WhatsappIcon, newTab: true, link: (url, text) => `https://wa.me/?text=${text}%20${url}` },
    { name: 'Telegram', Icon: TelegramIcon, newTab: true, link: (url, text) => `https://t.me/share/url?url=${url}&text=${text}` },
    { name: 'Email', Icon: EmailIcon, link: (url, text) => `mailto:?subject=${text}&body=${url}` },
];

export const ShareMenu = ({ listing }) => {
    const { t } = useTranslation(["details"]);
    const ref = useRef(null);
    const [open, setOpen] = useState(false);
    const [copied, setCopied] = useState(false);
    const [alignLeft, setAlignLeft] = useState(false);

    // the menu hangs from the button's right edge, unless the button sits too far left for it to fit
    const toggle = () => {
        if (!open) setAlignLeft(ref.current.getBoundingClientRect().right < MENU_WIDTH + SCREEN_MARGIN);
        setOpen(!open);
    };

    useEffect(() => {
        if (!open) return;
        const onDown = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
        document.addEventListener('mousedown', onDown);
        document.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('mousedown', onDown);
            document.removeEventListener('keydown', onKey);
        };
    }, [open]);

    const shareUrl = `${window.location.origin}/oglas/${listing.id}`;
    const url = encodeURIComponent(shareUrl);
    const text = encodeURIComponent(listing.title || '');

    const copy = () => {
        try {
            navigator.clipboard?.writeText(shareUrl);
        } catch (e) { }
        setCopied(true);
        setTimeout(() => setCopied(false), COPIED_MS);
    };

    return (
        <div className='hs-share' ref={ref}>
            <button className={open ? 'open' : ''} aria-expanded={open} onClick={toggle} aria-label={t('share')} title={t('share')}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7" /><path d="m16 6-4-4-4 4M12 2v13" /></svg>
                <span className='hs-det-tool-label'>{t('share')}</span>
            </button>
            {open &&
                <div className={`hs-share-menu ${alignLeft ? 'left' : ''}`}>
                    {NETWORKS.map(({ name, Icon, link, newTab }) => (
                        <a key={name} className='hs-share-opt' href={link(url, text)} target={newTab ? '_blank' : undefined} rel='noopener noreferrer' onClick={() => setOpen(false)}>
                            <Icon size={ICON_SIZE} round />{name}
                        </a>
                    ))}
                    <button className='hs-share-opt' onClick={copy}>
                        <span className='hs-share-copy-icon'>
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7" /><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7" /></svg>
                        </span>
                        {copied ? t('link_copied') : t('copy_link')}
                    </button>
                </div>}
        </div>
    );
};
